module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab2",
      "name": "hres31x-tab2"
    }
  }, [_c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['290']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codblood']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['v_weight']) + " " + _vm._s(_vm.constLabels[_vm.nowLang].kilogram))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['v_high']) + " " + _vm._s(_vm.constLabels[_vm.nowLang].centimater))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codrelgn']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codorgin']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codnatnl']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['190']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteempdb'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['coddomcl']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['200']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['stamarry']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['210']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['stamilit']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numappl']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numprmid']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteprmst'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteprmen'])))])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-id-card-o icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['220']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['230']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numoffid']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['240']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['adrissue']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['250']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codprovi']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['260']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteoffid'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numpasid']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dtepasid'])))])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic3
    }
  }, [_c('i', {
    staticClass: "fa fa-id-card-o icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.constLabels[_vm.nowLang].driverC))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic3),
      expression: "subTopic3"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numlicid']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dtelicid'])))])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic4
    }
  }, [_c('i', {
    staticClass: "fa fa-home icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['270']) + _vm._s(_vm.labels['HRES31XC2']['280']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic4),
      expression: "subTopic4"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['280']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['adrregt']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['290']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['dessubdistr']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['300']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['desdistr']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['310']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['desprovr']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['320']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['descntyr']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['330']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codpostr']))])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic5
    }
  }, [_c('i', {
    staticClass: "fa fa-home icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['340']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic5),
      expression: "subTopic5"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['340']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['adrconte']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['350']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['dessubdistc']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['360']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['desdistc']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['370']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['desprovc']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['380']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['descntyc']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['390']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codpostc']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC2']['400']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numtelec']))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7225457e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab2.vue
// module id = 3864
// module chunks = 1